import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import EditStudyGroupForm from "components/Admin/StudyGroups/EditStudyGroupForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";
import _ from "lodash";
import { getAdminStudygroup } from "../../../actions/studygroups";

const { UPDATE_STUDY_GROUP_SAGA } = constants;

const {
  updateStudygroup,
  cleanErrors,
  getSuperhosts,
  cleanStudyGroup,
  // adminUserFilter,
} = actions;

class EditStudyGroup extends Component {
  static propTypes = {
    updateStudyGroup: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.object,
    errorsFrontend: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      studyGroup: {
        title: "",
        superhost_ids: [],
        show_for_users: false,
        logo: null,
        logo_url: "",
      },
    };
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.state.studyGroup, props.studyGroup)) {
      this.setState({
        studyGroup: {
          ...this.state.studyGroup,
          ...props.studyGroup,
        },
      });
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadStudyGroup(this.props.params.id);
    this.props.getSuperhosts({}, "all");
    // this.props.loadUsers({per_page: 'all'}, 'all');
  }

  componentWillUnmount() {
    this.props.cleanStudyGroup();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const studyGroupData = {
      ...this.state.studyGroup,
      [e.target.name]: input,
    };

    this.setState({ studyGroup: studyGroupData });
  };

  onIdsChange = (roles) => {
    this.onFieldChange({
      target: {
        name: "superhost_ids",
        value: (roles || []).map((role) => role.value),
      },
    });
  };

  handleFileChange = (file) =>
    this.setState({
      studyGroup: {
        ...this.state.studyGroup,
        logo: file,
        logo_url: URL.createObjectURL(file),
      },
    });

  onSubmit = () => {
    this.props.updateStudyGroup(this.state.studyGroup);
  };

  handleShowChange = (value) =>
    this.setState({
      studyGroup: { ...this.state.studyGroup, show_for_users: value },
    });

  render() {
    const { errors, errorsFrontend, superhosts, members } = this.props;
    const superhostsOptions = (superhosts || []).map((superhost) => ({
      value: superhost.id,
      label: `${superhost.first_name} ${superhost.last_name}`,
    }));
    // const membersOptions = (members || []).map(member => ({value: member.id, label: member.full_name}))

    return (
      <main className="site--width clearfix-c">
        <EditStudyGroupForm
          onFieldChange={this.onFieldChange}
          onIdsChange={this.onIdsChange}
          studyGroup={this.state.studyGroup}
          superhosts={superhostsOptions}
          // members={membersOptions}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
          handleShowChange={this.handleShowChange}
          handleFileChange={this.handleFileChange}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[UPDATE_STUDY_GROUP_SAGA],
    errorsFrontend: state.errors[`${UPDATE_STUDY_GROUP_SAGA}_FRONTEND`],
    superhosts: state.superhosts.superhosts.values,
    studyGroup: state.studygroups.tmp,
    // members: state.users.adminUsers.values,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateStudyGroup: (studyGroup) => dispatch(updateStudygroup(studyGroup)),
    cleanErrors: () => dispatch(cleanErrors(UPDATE_STUDY_GROUP_SAGA)),
    loadStudyGroup: (id) => dispatch(getAdminStudygroup(id)),
    getSuperhosts: (query, page) => dispatch(getSuperhosts(query, page)),
    // loadUsers: (query, page, per_page) => dispatch(adminUserFilter(query, page, per_page)),
    dispatch: dispatch,
    cleanStudyGroup: () => dispatch(cleanStudyGroup()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditStudyGroup);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/EditStudyGroup.jsx